import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Input } from '../../../../../../../components/FormComponents';
import { type SupplierFormData } from '../../../types';

export const MessagingNotifications: React.FC = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<SupplierFormData>();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Messaging Notifications</h3>

      <div className="space-y-4">
        <Input
          id="whatsappNumber"
          label="WhatsApp Number"
          value={watch('notificationWhatsappNumber')}
          onChange={(value) =>
            setValue('notificationWhatsappNumber', value, { shouldDirty: true })
          }
          errorMessage={errors.notificationWhatsappNumber?.message}
          isInvalid={!!errors.notificationWhatsappNumber}
          className="max-w-md"
        />

        <Input
          id="smsNumber"
          label="SMS Number"
          value={watch('notificationSmsNumber')}
          onChange={(value) =>
            setValue('notificationSmsNumber', value, { shouldDirty: true })
          }
          errorMessage={errors.notificationSmsNumber?.message}
          isInvalid={!!errors.notificationSmsNumber}
          className="max-w-md"
        />
      </div>
    </div>
  );
};
